import * as React from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import { Card, List, ListItem, Typography } from "@mui/material";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function TabsmigrateProvider() {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Card>
      <Box sx={{ width: "100%" }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="basic tabs example"
          >
            <Tab
              label="Pre-Requisites"
              {...a11yProps(0)}
              sx={{
                backgroundColor: "white",
                borderRadius: 1,
                "&:hover": {
                  backgroundColor: "white",
                },
                "&.Mui-selected": {
                  backgroundColor: "white",
                },
              }}
            />
            <Tab
              label="How to Migrate?"
              {...a11yProps(1)}
              sx={{
                backgroundColor: "white",

                borderRadius: 1,
                "&:hover": {
                  backgroundColor: "white",
                },
                "&.Mui-selected": {
                  backgroundColor: "white",
                },
              }}
            />
          </Tabs>
        </Box>
        <CustomTabPanel value={value} index={0}>
          <List sx={{ listStyleType: "disc", pl: 2.5 }}>
            <ListItem sx={{ display: "list-item", fontSize: "14px" }}>
              Have admin access to the Business Portfolio Account in which the
              existing number is registered.
            </ListItem>
            <ListItem sx={{ display: "list-item", fontSize: "14px" }}>
              Have access to mobile number on which you will receive OTP as part
              of the process.
            </ListItem>
          </List>
        </CustomTabPanel>
        <CustomTabPanel value={value} index={1}>
          <List sx={{ listStyleType: "disc", pl: 2.5 }}>
            <ListItem sx={{ display: "list-item", fontSize: "14px" }}>
              Select "Migrate From Different Provider".
            </ListItem>
            <ListItem sx={{ display: "list-item", fontSize: "14px" }}>
              Disable 2 factor authentication on existing WABA account. Detailed
              Steps will be provided when you select on "Migrate From Different
              Provider".
            </ListItem>
            <ListItem sx={{ display: "list-item", fontSize: "14px" }}>
              Click on "Connect Facebook Account", you will be taken to
              Facebook, complete the steps as guided by Facebook Pop Up. You
              will be redirected back here to continue with further steps.
            </ListItem>
            <ListItem sx={{ display: "list-item", fontSize: "14px" }}>
              Verify Mobile Number : Enter the mobile number, initiate OTP,
              Enter OTP & submit.
            </ListItem>
          </List>
          <Typography variant="subtitle2" color="text.secondary">
            With this, you have successfully completed the Migration.
          </Typography>
        </CustomTabPanel>
      </Box>
    </Card>
  );
}
